import { isDefined } from '@freelancer/utils';
import type { BusinessBuilderAttempt } from './business-builder-attempt.model';
import type { BusinessBuilderBlueprint } from '../business-builder/business-builder.model';

export function parseAttemptBlueprint(
  attempt: BusinessBuilderAttempt | undefined,
): BusinessBuilderBlueprint | undefined {
  if (!attempt) {
    return undefined;
  }
  try {
    return JSON.parse(attempt.phasesData) as BusinessBuilderBlueprint;
  } catch {
    return undefined;
  }
}

export function attemptHasPostedProject(
  attempt: BusinessBuilderAttempt | undefined,
): boolean {
  const blueprint = parseAttemptBlueprint(attempt);
  return (blueprint?.phases ?? []).some(phase =>
    (phase.projects ?? []).some(project => isDefined(project.projectId)),
  );
}
